import { render } from "./IssueArticleListControl.vue?vue&type=template&id=0bd82c17"
import script from "./IssueArticleListControl.vue?vue&type=script&lang=js"
export * from "./IssueArticleListControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__